/* Alters the position of the Chat With Us button so it can't be hidden by the GDPR alert */

export function salesforce_chat_position() {

	( ( $ ) => {

		const chat_without_bottom_value = () => {
			$( '.embeddedServiceHelpButton .helpButton' ).removeAttr( 'style' );
		}

		const chat_reposition = () => {
			let interval = setInterval( () => {				
				const salesforce_chat_button = $( '.embeddedServiceHelpButton .helpButton' );
				const gdpr_bar = $( '#moove_gdpr_cookie_info_bar' );
	
				if ( salesforce_chat_button.length > 0 && gdpr_bar.length > 0 && $( 'body' ).hasClass( 'gdpr-infobar-visible' ) ) {
					const gdpr_bar_height = gdpr_bar.css( 'height' );
					salesforce_chat_button.css( 'bottom', gdpr_bar_height );
					clearInterval( interval );	
				}
			}, 50 );
		}

		chat_reposition();

		$( window ).on( 'resize', chat_reposition );
		$( document ).on( 'click', '.moove-gdpr-infobar-allow-all', chat_without_bottom_value );

	} )( window.jQuery );

}